import { getMemberNotifications } from 'libs/apis';
import type { Notification } from 'components/notification/type';

/*
  APIによるお知らせの取得
 */
export const fetchNotifications = (limit: number): Promise<Notification[]> =>
  getMemberNotifications({ limit }).then((res) => res.memberNotifications);
